import * as React from 'react';

import { ChatMessageContent } from '../../../components/ChatMessageContent';
import { useMessageContentType } from '../hooks/useMessageContentType';
import { useUserColor } from '../hooks/useUserColor';
import { ActionButtonsContainer } from './ActionButtonsContainer';
import { ChatMessageMetaContainer } from './ChatMessageMetaContainer';
import { DocumentMessageContainer } from '../../DocumentMessageContainer';
import { ErrorSignContainer } from './ErrorSignContainer/ErrorSignContainer';
import { ImageAsDocumentMessageContainer } from '../../ImageAsDocumentMessageContainer';
import { ImageMessageContainer } from './ImageMessageContainer';
import { MessageReplyQuoteContainer } from '../../MessageReplyQuoteContainer';
import { OfferMessageContainer } from '../../OfferMessageContainer';
import { TextMessageContainer } from './TextMessageContainer';
import { UserNameContainer } from './UserNameContainer/UserNameContainer';
import { ErrorTextContainer } from './ErrorTextContainer';
import { ChatMessageReplyLayout } from '../../../components/ChatMessageReplyLayout/ChatMessageReplyLayout';
import { useMessageContext } from '../../../utils/messageContext';
import { useScrollOnActiveReplyPreview } from '../hooks/useScrollOnActiveReplyPreview';
import { useScrollToReplyTarget } from '../hooks/useScrollToReplyTarget';

export const ChatMessageContentContainer: React.FC = () => {
  const { message, messageId, messageType, isLastInChain, messageRef } = useMessageContext();

  const { highlighted, onHighlightEnd } = useScrollToReplyTarget({ messageId, messageRef });

  const userColor = useUserColor(message);
  const contentType = useMessageContentType({ message, messageId });

  useScrollOnActiveReplyPreview({ messageId, messageRef });

  return (
    <ChatMessageReplyLayout>
      <ChatMessageContent
        ref={messageRef}
        contentType={contentType}
        messageType={messageType}
        isLastMessageInChain={isLastInChain}
        highlighted={highlighted}
        onHighlightEnd={onHighlightEnd}
        errorText={<ErrorTextContainer />}
        replyQuote={<MessageReplyQuoteContainer />}
        errorSign={<ErrorSignContainer />}
        offerMessage={<OfferMessageContainer />}
        documentMessage={<DocumentMessageContainer />}
        imageAsDocumentMessage={<ImageAsDocumentMessageContainer />}
        imageMessage={<ImageMessageContainer />}
        textMessage={<TextMessageContainer />}
        userName={<UserNameContainer />}
        actionButtons={<ActionButtonsContainer />}
        messageMeta={<ChatMessageMetaContainer />}
        userColor={userColor}
        deletedMessage={message.message}
      />
    </ChatMessageReplyLayout>
  );
};
